import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";

import loaderWithRetry from "seneca-common/utils/loaderWithRetry";

import { ActivateTutoringJourneyParamKey } from "../consts";

const TutoringActivationJourneyRoutes = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "tutoring-activation-journey" */ "./SubRouter"
      )
  )
);

export default function TutoringActivationJourneyRoute() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  if (!params.has(ActivateTutoringJourneyParamKey)) return null;

  return (
    <Suspense fallback={null}>
      <TutoringActivationJourneyRoutes />
    </Suspense>
  );
}
